import React from "react";
import { PageShell } from "../components/Layout";
import SeoContent from "../components/SeoContent";
import { api, dmyToSlash } from "../services/api";
import useSeo from "../hooks/useSeo";

function HeaderCell({ children, last }) {
  return (
    <div
      className={`flex items-center justify-center bg-[#f4552a] text-white font-extrabold text-base sm:text-xl ${
        last ? "" : "border-r-2 border-white/70"
      }`}
    >
      {children}
    </div>
  );
}

function ValueCell({ children, last }) {
  return (
    <div
      className={`flex items-center justify-center bg-white text-[#1f2733] font-black text-xl sm:text-3xl ${
        last ? "" : "border-r border-gray-200"
      }`}
    >
      {children}
    </div>
  );
}

export default function CommonNumber() {
  const [c, setC] = React.useState(null);
  useSeo({
    title: "Sunday Ground Teer Common Number Today | F/R & S/R",
    description:
      "Today's Sunday Ground Teer Common Number - Direct, House & Ending for First Round (F/R) and Second Round (S/R), calculated from previous Shillong Teer results.",
  });

  React.useEffect(() => {
    api.commonNumber().then(setC).catch(() => setC(null));
  }, []);

  if (!c) {
    return (
      <PageShell title="Common Number" subtitle="Sunday Ground Teer Common Number">
        <div className="text-center text-gray-400 py-10">Loading...</div>
      </PageShell>
    );
  }

  return (
    <>
      <PageShell
        title="Common Number"
        subtitle={`Sunday Ground Teer Common Number • ${dmyToSlash(c.date)}`}
      >
        {/* Direct / House / Ending box — 16:9 */}
        <div className="mx-auto w-full" style={{ maxWidth: "760px" }}>
          <div
            className="rounded-2xl overflow-hidden shadow-lg bg-white flex flex-col"
            style={{ aspectRatio: "16 / 9" }}
          >
            <div className="flex items-center justify-center bg-[#1f2733] text-white font-black text-xl sm:text-3xl py-2 rounded-t-2xl">
              Date: {dmyToSlash(c.date)}
            </div>
            <div className="grid grid-cols-3 flex-1 border-t border-gray-200">
              <HeaderCell>Direct</HeaderCell>
              <HeaderCell>House</HeaderCell>
              <HeaderCell last>Ending</HeaderCell>
            </div>
            <div className="grid grid-cols-3 flex-1">
              <ValueCell>{c.fr.direct}</ValueCell>
              <ValueCell>{c.fr.house}</ValueCell>
              <ValueCell last>{c.fr.ending}</ValueCell>
            </div>
            <div className="grid grid-cols-3 flex-1">
              <HeaderCell>Direct</HeaderCell>
              <HeaderCell>House</HeaderCell>
              <HeaderCell last>Ending</HeaderCell>
            </div>
            <div className="grid grid-cols-3 flex-1 border-b border-gray-200">
              <ValueCell>{c.sr.direct}</ValueCell>
              <ValueCell>{c.sr.house}</ValueCell>
              <ValueCell last>{c.sr.ending}</ValueCell>
            </div>
          </div>
          <div className="flex justify-between mt-2 px-1 text-xs font-semibold text-gray-500">
            <span>F/R • 4:30 PM</span>
            <span>S/R • 5:30 PM</span>
          </div>
        </div>

        <p className="text-center text-xs text-gray-400 mt-4">
          * Common numbers are probability based. Play responsibly.
        </p>
      </PageShell>
      <SeoContent variant="common" />
    </>
  );
}
